import React, {useEffect} from "react";
import {useFormikContext} from "formik";

import { Form} from "react-bootstrap";


function AppFormField({name, display, width, label, defaultValue, ...otherProps}) {
    const {setFieldTouched, setFieldValue, values} = useFormikContext();

    useEffect(() => {
        if (defaultValue) setFieldValue(name, defaultValue)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (display) {
        if (values[display.name] !== display.value) return <></>
    }

    return <div>
        <Form.Label>
            {label}
        </Form.Label>
        <Form.Control
        onBlur={() => setFieldTouched(name[0])}
        onChange={text => setFieldValue(name[0], text.target.value)}
        value={values[name[0]]}
        width={width}
        {...otherProps}
    />
    </div>
}

export default AppFormField;
